import { QueryClient } from 'react-query';

const client = new QueryClient();

export const queryClient = client;
